import React, { lazy } from 'react'
import { useFeatureFlagVariantKey } from '@posthog/react'
import { get as getConfig } from 'config'
import Sherpa, { TYPE_LARGE } from 'components/Sherpa'
import { POSTHOG_FEATURE_FLAGS } from 'components/PostHog'

const LoadableSearch = lazy(
  () => import('components/SearchPage'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)
const LoadableAiGuideSearch = lazy(
  () => import('components/AiGuideSearchPage'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

export default function SearchPageSwitch (props) {
  const config = getConfig()
  const configEnabled = !!config?.features?.ai?.aiGuideSearchPage
  const isPostHogEnabled = !!config?.features?.posthog
  const yonLaurenVariant = useFeatureFlagVariantKey(
    POSTHOG_FEATURE_FLAGS.COMMUNITY_YON_LAUREN_INITIAL_TEST,
  )

  const showAiSearch = configEnabled && (!isPostHogEnabled || yonLaurenVariant === 'email-matched')

  if (showAiSearch) {
    return <LoadableAiGuideSearch history={props.history} location={props.location} />
  }
  return <LoadableSearch history={props.history} location={props.location} />
}
